export default {
  button: {
    add: '新增',
    determine: '确定',
    cancel: '取 消',
    search: '查询',
    copy: '复制',
    reset: '重置',
    edit: '编辑',
    delete: '删除',
    resetPassword: '重置密码',
    submit: '提 交',
    append: '添加',
    addFriend: '添加同级',
    save: '保存',
    export: '导出',
    IDprint: '身份证明打印',
    appendNLeaf: '添加非叶子节点',
    addLeaf: '添加叶子节点',
    batchBind: '批量绑定',
    singleBind: '单个绑定',
    telnetCheck: '网络测试',
    initJob: '初始化任务',
    clearJob: '清空所有任务',
    upgradeConfig: '升级策略管理'
  },
  navbar: {
    logOut: '退出',
    dashboard: '首页',
    title: '智能管理系统',
    fold: '菜单折叠',
    switch: '中文/EN',
    hello: '您好，',
    versionName: '版本名称',
    about: '关于',
    changePassword: '修改密码',
    menu: 'item.permisName',
    allMenus: '所有菜单',
    commonMenu: '常用菜单'
  },
  login: {
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    remember: '记住密码',
    reset: '重置'
  },
  prompt: {
    outTips: '此操作将退出登录, 是否继续?',
    deleteTips: '此操作将永久删除该信息, 是否继续?',
    deleteFailed: '删除失败',
    deleteSuccessful: '删除成功',
    sucessful: '操作成功',
    addSuccessful: '新增成功',
    addFailed: '新增失败',
    updateSuccessful: '修改成功',
    updateFailed: '修改失败',
    validFailed: '提交失败，请检查后重新提交',
    submitFailed: '提交失败，请重新提交',
    selectLine: '请选择一行数据',
    resetPasswordTips: '确定要重置密码?',
    resetPasswordSuccessful: '密码重置成功',
    resetPasswordFailed: '密码重置失败',
    prompt: '提示',
    switchTips: '确定要切换语言吗？',
    messageIsNull: '返回数据为空',
    loginTimeOut: '登录超时，请重新登录!',
    changePasswordSuc: '密码修改成功,请重新登陆',
    upgradeUpdateTips: '修改升级规则、设备厂商将清空之前选择的升级设备列表，是否确认修改',
  },
  table: {
    articleName: '物品名称',
    articleType: '物品类型',
    articleterminal: '绑定设备',
    grantUser: '授权人员',
    latticeNum: '柜格编号',
    tagNo: '标签编号',
    cardNo: '卡号',
    idCard: '证件号',
    BoEing: 'BoEing',
    articleStatus: '物品状态',
    bindStatus: '绑定状态',
    workWeekend: '周末是否营业',
    workTime: '营业时间',
    transCode: '交易码',
    transName: '交易名称',
    userName: '姓名',
    account: '员工号',
    numberOfSubstructures:'子机构数',
    organization: '所属机构',
    userStatus: '用户状态',
    receiveMessage: '是否接收短信',
    mobileNo: '手机号码',
    operation: '操作',
    phoneNo: '电话号码',
    email: '邮箱',
    yes: '是',
    no: '否',
    remark: '描述信息',
    unselectedRole: '未选择权限',
    selectedRole: '已选择权限',
    add: '新增',
    edit: '修改',
    resKey: '资源KEY',
    displayValue: '显示值',
    realValue: '真实值',
    resOrder: '资源排序',
    parameterKey: '参数名称',
    parameterValue: '参数值',
    parameterDesc: '描述信息',
    orgName: '机构名称',
    shortName: '机构简称',
    orgCode: '机构编码',
    orgLevel: '机构级别',
    orgState: '机构状态',
    contUser: '联系人',
    postCode: '邮编',
    address: '地址',
    permisName: '菜单名称',
    permisCode: '菜单码',
    pagePath: '页面路径',
    permisType: '菜单类型',
    permisUrl: '链接',
    permisOrder: '排序',
    roleName: '权限名称',
    roleCode: '权限码',
    changePassword: '修改密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    password: '确认密码',
    shotName: '厂商简称',
    type: '厂商类型',
    attactUser: '联系人',
    emailAddr: '邮箱',
    attactAddr: '地址',
    choose: '请选择',
    input: '请输入',
    //devicePart
    partName: '模块名称',
    zhPartName: '中文名称',
    ocxId: '控件ID',
    modName: '调用方法名称',
    serviceClassify: "模块类接口类型",
    serviceName: "服务名称",
    isRecommend: "是否推荐",
    //deviceType
    typeRemark: '备注',
    typeCode: '设备类型',
    typeName: '类型名称',
    //serviceEngineer
    engineerName: '姓名',
    engineerSupplierName: '维护商',
    enginnerRemark: '备注',
    // service
    //公用的参数值
    //备注的长度参数
    remarkLength: '100',
    tellerNo: '柜员号',
    tellerName: '姓名',
    //全行参数
    key: '参数KEY',
    value: '参数值',
    deviceTypeBean: '渠道',
    paramRemark: '描述信息',
    //monitor
    monitorName: '参数名',
    monitorValue: '参数值',
    monitoryRemark: '备注',
    menuName: '菜单名称',
    menuEnname: '菜单英文名',
    enMenuName: '菜单英文名',
    serviceLink: '服务链接',
    modelInfo: '模块信息',
    buttonPost: '按钮位置',
    displayName: '服务名',
    selectedModule: '已选模块',
    unselectedModule: '未选模块',
    readCard: '读卡配置',
    status: '状态',
    pubChn: '属于公共渠道',
    templateName: '模板名称',
    unselectedPart: '未选择模块',
    selectedPart: '已选择模块',

    faultDeviceType: '设备类型',
    faultOrgName: "所属机构",
    faultPolicyName: "故障类型",
    policyName: "响应名称",
    peincipalType: "负责人类型",
    responseTime: "响应时间(分)",
    closeTime: "关闭时间(分)",
    noticeStartTime: "开始时间",
    noticeEndTime: "截止时间",
    noticeInterval: "时间间隔",
    smsNotice: "是否短信",
    smsNoticeCounts: "短信次数",
    saturdayWork: "周六",
    sundayWork: "周日",
    restoreTag: "故障状态",
    firstTime: "发生时间",
    faultPartName: "模块名称",
    faultDescribe: "故障描述",
    /* 设备信息 */
    terminalId: '设备编号',
    orgId: '所属机构',
    vertualUserNum: '虚拟柜员',
    ipAddr: 'IP地址',
    terminalState: '终端状态',
    batchBind: '批量绑定',
    singleBind: '单个绑定',

    /** 实时交易监控 */
    transTime: '交易时间',
    transType: '交易类型',
    transTimeCost: '交易用时',
    channelType: '渠道类型',
    transAmount: '交易金额',
    accountNum: '交易账号',
    pRetCode: 'P端返回码',
    retMsg: '返回信息',
    /** 系统操作日志 */
    operator: '操作员',
    remoteHost: '主机地址',
    operationContent: '操作内容',
    operationTime: '操作时间',
    to: '至',

    managerState: '用户状态',
    IDnumber: '身份证号',
    supplierName: '设备厂商',
    modelName: '设备型号',
    cVersion: 'C端版本',
    spVersion: 'SP版本',
    monitorStatusTime: '更新时间',
    //
    packName: '升级包名称',
    packContent: '版本说明',
    md5: 'MD5校验值',
    packVersion: '版本号',
    supplierPackName: '设备厂商',
    packType: '升级包类型',
    packTime: '上传时间',
    downCompFlag: '是否全量包',
    isExecuteNow: '是否立即升级',
    file: '升级包',
    deviceType: '设备类型',
    downloadUrl: '下载路径',
    upgradeGroup: '升级规则',

    //广告
    name: '广告名',
    url: '文件路径',
    intervalTime: '轮播时间',
    preview: '预览',
    uploadTime: '上传时间',
    adsconfType: '广告类型',
    jobType: '任务名称',
    jobTime: '执行时间',
    timeCron: '10 10 10 * * ? *',

    //地区码
    areaCode: '地区码',
    divisionCode: '行政编码',
    divisionName: '地名',
    parentDivisionCode: '上级地区',
    keywords: '关键字',
    icon: '图标',

    //预警
    alarmCode: '预警编码',
    alarmType: '预警类型',
    saturdayWork: '周六是否推送',
    sundayWork: '周日是否推送',

    creator: '创建人',
    createDate: '创建时间',

  },
  search: {
    iptTaskName:'请输入任务名称',
    iptLockName:'请输入锁名称',
    iptKeyName:'请输入钥匙名称',
    iptNumber:'请输入编号',
    iptSerialNumber:'请输入序列号',
    iptBatchNumber:'请输入批次号',
    iptFenceName:'请输入电子围栏名称',
    iptDeviceNumber:'请输入设备编号',
    iptIP:'请输入IP地址',
    iptModelName:'请输入型号名称',
    iptDeviceType:'请输入设备类型',
    iptTypeName:'请输入类型名称',
    iptOrgName:'请输入机构名称',
    iptUserName:'请输入用户姓名',
    iptEmployeeNo:'请输入员工号',
    iptIDCard:'请输入证件号',
    iptIphoneNo:'请输入手机号码',
    iptMenuName:'请输入菜单名称',
    iptKEY:'请输入资源KEY',
    iptShowValue:'请输入显示值',
    iptTrueValue:'请输入真实值',
    iptParameterName:'请输入参数名称',
    iptParameterNum:'请输入参数值',
    iptOperator:'请输入操作员',
    iptUserOperator:'请输入操作人',
    iptRemarks:'请输入备注',
    iptAlarmUser:'请输入告警用户名',
    iptDeviceManufacturer:'请输入设备厂商',
    iptAlarmContent:'请输入告警内容',

    selState:'请选择状态',
    selPower:'请选择权限',
    selUserState:'请选择用户状态',
    selRecordType:'请选择记录类型',
    selOperationType:'请选择操作类型',
    selTerminalState:'请选择终端状态',
    selDeviceType:'请选择设备类型',
    selDeviceManufacturer:'请选择厂商',
    selNotificationMethods:'请选择通知方式',
    selAlarmState:'请选择告警状态',
  },
  titleTip: {
    orderPolicy:'通知策略',
    user: '用户',
    systemParamter: '系统参数',
    role: '权限',
    permis: '菜单',
    serviceInfo: '服务信息',
    servDeviceTypeTemp: '服务模板',
    singleBindServ: '单个绑定服务',
    batchBindServ: '批量绑定服务'
  },
  errorLog: {
    enterName: '请输入姓名',
    enterStatus: '请输入用户状态',
    enterOrg: '请输入机构',
    enterAccount: '请输入登录账户',
    enterResKey: '请输入资源KEY（大写英文字母和下划线）',
    enterResOrder: '请输入资源排序',
    enterRealValue: '请输入真实值',
    enterDisplayValue: '请输入显示值',
    enterParameterKey: '请输入参数名称',
    enterParameterValue: '请输入参数值',
    enterOrgCode: '请输入机构码',
    enterOrgLevel: '请输入机构级别',
    enterOrgState: '请输入机构状态',
    enterPermisName: '请输入菜单名称',
    selectIcon: '请选择图标',
    enterPermisCode: '请输入菜单码',
    enterPermisType: '请选择菜单类型',
    enterRoleName: '请输入权限名称',
    enterRoleCode: '请输入权限码',
    roleNameLength: '权限名称长度不能超过50个字符',
    enterPassword: '密码不能为空',
    passwordinConsistent: '两次密码不一致',
    enterNumber: '请输入数字',
    //supplier
    enterSupplierName: '请输入厂商名称',
    enterType: '请选择厂商类型',
    enterPartName: '请输入模块名称',
    enterOcxId: '请输入控件ID',
    enterRemark: '请输入中文名称',
    enterModName: '请输入调用方法名称',
    enterServiceClassify: '请选择模块类接口类型',
    //deviceType
    enterTypeCode: '请输入类型编码',
    enterTypeRemark: '只能输入100个以内的字符数目',
    //serviceEngineer
    enterEngineerName: '请输入工程师姓名',
    enterMobileNo: '请输入正确格式的手机号',
    enterEngineerSupplierName: '请选择维护商',
    enterEmail: '请输入正确的邮箱格式',
    //parameter
    enterKey: '请输入参数KEY',
    enterValue: '请输入参数值',
    enterOrgName: '请选择所属机构',
    enterTypeName: '请选择渠道',
    enterParamRemark: '只能输入100个以内的字符数目',
    //monitor
    enterMonitorName: '请输入参数名',
    // 服务
    enterTempName: '请输入模板名称',
    enterMenuName: '请输入菜单名称',
    enterEnMenuName: '请输入菜单英文名称',
    enterButtonPost: '请选择按钮位置',
    enterServiceLink: '请输入服务链接名称',
    enterDisplayName: '请输入服务名',
    enterServiceName: '请输入服务调用名',

    enterTellerNo: '请输入柜员号',
    enterTellerName: '请输入柜员姓名',
    enterManagerState: '请选择用户状态',
    enterIDnumber: '请输入正确格式的身份证号',
    enterPackageName: '升级包名称不能为空',
    enterPackVersion: '升级包版本不能为空',
    enterPackContent: '升级包内容不能为空',
    enterPackType: '请选择升级包类型',
    enterDownCompFlag: '请选择是否全量包',
    enterIsExecuteNow: '请选择是否立即升级',
    enterMd5: 'MD5校验值不能为空',
    enterMonitorValue: '请输入参数值',
    //faultPolicy
    enterPolicyName: "请输入响应名称",
    enterPeincipalType: "请选择负责人类型",
    enterResponseTime: "请输入要求响应时间(分)",
    enterCloseTime: "请输入要求关闭时间(分)",
    enterNoticeStartTime: "请选择开始时间",
    enterNoticeEndTime: "请选择截止时间",
    enterSmsNoticeCounts: "请输入短信次数",
    enterSaturdayWork: "请选择周六状态",
    enterSundayWork: "请选择周日状态",
    enterNoticeInterval: "请选择通知时间间隔",
    enterSmsNotice: "请选择是否短信通知",

    //adsHeadMag
    enterIntervalTime: "轮播时间不能为空",

    //adsHeadCfg
    enterAdsType: "广告类型不能为空",

    //administrative
    enterDivisionCode: "行政编码不能为空",
    enterParentDivisionCode: "请选择所属区",
    enterAreaCode: "地区码不能为空",
    enterDivisionName: "地名不能为空",

    //upgradePack
    enterSupplierId: "请选择厂商",
    enterUpgradePack: "请选择升级规则",
  },
  excel: {
    export: '导出',
    selectedExport: '导出已选择项',
    placeholder: '请输入文件名(默认excel-list)'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  form: {
    itemAttribute: '搜索框配置',
    itemsAsset: '搜索类型',
    JSON: 'json转页面',
    attribute: '表单属性'

  },
  code: {
    copy: '复制代码'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js